export type UID = string

export enum FlowChartBlockType {
  TEXT = 'text',
  ATTACHMENT = 'attachment',
  ATTACHMENT_PREVIEW = 'attachment_preview',
  DELAY = 'delay',
  USER_INPUT = 'user_input',
  DYNAMIC = 'dynamic',
  TELEGRAM_KEYBOARD = 'telegram_keyboard',
  SUBSCRIBE_REQUEST = 'subscribe_request',
  CARDS = 'cards',
  QUICK_REPLIES = 'quick_replies',
  MEDIA_MESSAGE = 'media_message',
  LIST_MESSAGE = 'list_message',
  CATALOG = 'catalog',
  PLACEHOLDER = 'placeholder',
  EMPTY_NODE = 'empty_node',
  EMAIL_CONTENT = 'email_content',
}

export interface FlowChartBlock {
  type: FlowChartBlockType
  id: string
  data: object
}
